import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { BeneficiaryInitResponse } from "./types/BeneficiaryInit";
import { BeneficiaryOrder } from "./types/BeneficiaryOrder";
import { BeneficiaryPutRequest } from "./types/BeneficiaryCommand";
import { BeneficiaryState } from "./types/BeneficiaryState";

const initialState: BeneficiaryState = {
  loading: false,
  successfulAction: false,
  error: "",
  init: {
    beneficiariesChecked: false,
    beneficiariesRequired: false,
    orderId: "",
  },
  beneficiaryOrder: {
    id: "",
    complete: false,
    customer: {
      firstName: "",
      lastName: "",
      nin: "",
    },
    externalReference: "",
    documents: [],
  },
};

interface BeneficiaryOrderRquest {
  orderId: string;
}

interface BeneficiaryInitRequest {
  caseId: string;
}

const beneficiarySlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    requestBeneficiaryOrder: (
      state,
      action: PayloadAction<BeneficiaryOrderRquest>,
    ) => {
      state.beneficiaryOrder = initialState.beneficiaryOrder;
      state.loading = true;
      state.error = "";
    },
    requestBeneficiaryOrderSuccessful: (
      state,
      action: PayloadAction<BeneficiaryOrder>,
    ) => {
      state.loading = false;
      state.beneficiaryOrder = action.payload;
    },
    requestBeneficiaryOrderFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    requestBeneficiaryInit: (
      state,
      action: PayloadAction<BeneficiaryInitRequest>,
    ) => {
      state.loading = true;
      state.successfulAction = false;
    },
    requestBeneficiaryInitSuccessful: (
      state,
      action: PayloadAction<BeneficiaryInitResponse>,
    ) => {
      state.loading = false;
      state.init.beneficiariesRequired = action.payload.beneficiariesRequired;
      state.init.orderId = action.payload.orderId;
      state.init.beneficiariesChecked = true;
    },
    requestBeneficiaryInitFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.init.beneficiariesChecked = false;
    },
    requestPutBeneficiaryRequest: (
      state,
      action: PayloadAction<BeneficiaryPutRequest>,
    ) => {
      state.loading = true;
      state.successfulAction = false;
    },
    requestPutBeneficiaryRequestSuccessful: (
      state,
      action: PayloadAction<any>,
    ) => {
      state.successfulAction = true;
    },
    requestPutBeneficiaryRequestFailed: (
      state,
      action: PayloadAction<string>,
    ) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { actions } = beneficiarySlice;
export const {
  requestBeneficiaryOrder,
  requestBeneficiaryInit,
  requestPutBeneficiaryRequest,
} = actions;
export default beneficiarySlice.reducer;
